/*
Sohel 01/03/2022 2789725780 reset Basic Info Data
Sohel 01/04/2022 2789725780 Search Table Changes
Sohel 01/05/2023 2789725780 integrated Delete API
dilip 01/06/2023 2789725780 added save and close for mapped record group data.
Sohel 01/06/2022 3075154998 added condition on For API call in Table
dilip 01/09/2023 3075154998 Added search data local storage
dilip 01/09/2023 3075154998 fixed payload issue.
Sohel 01/10/2023 3075154998 changed Search Table Payload.
kavyareddy 01/10/2023 3075154998 Added download configuration button
kavyareddy 01/10/2023 3075154998 Fixed toast msg issue
Sohel 01/10/2023 2699299906 Implemented Copy Functionality
Dilip 01/11/2023 2699299906 Implemented System Notes Functionality
Sohel 01/12/2023 2699299906 isDraft Changes
dilip 01/12/2023 2699299906 Added Map Exception Records condition.
dilip 01/12/2023 2699299906 Fixed message and status reset issue.
dilip 01/12/2023 2699299906 Fixed check box disable issue.
sai krishna 01/17/2023 2699299906 copy popup label changed
Lalitha  01/18/2023  2699299906 renamed delete the popup heading and message
Sohel 01/18/2023 3075154998 fixed reset Issue
Sohel 01/18/2023 3075154998 Download Configuration Payload Changes
Sohel 01/18/2023 2698951347 Fixed Status  issue
Sohel 01/20/2023 2789725780 Added LastStep in payload
Sohel 01/20/2023 2698951347 Fixed page break issue
dilip 01/20/2023 2698951347 Added Map Exception functionality for IM Record Group
Sohel 01/20/2023 2698951347 Download Configuration Payload Changes
Sohel 01/23/2023 2698951347 fixed length populate issue
Ashraf 01/27/2023 2698951347 conditional render of payload props.
Sohel 01/31/2023 2698951347 label changes
Dilip 01/31/2023 2698951347 label and title changes
Sohel 01/02/2023 2698951347 fixed code hyperlink issue
Sohel 01/08/2023 2701335619 implemented Usage Functionality
Sohel 01/09/2023 2698951347 fixed page break issue
Ravi 02/09/2023 2698951347 Added used in Usage Toast
Dilip 02/09/2023 2698951347 added creted for and created by columns  and payload changes
suresh peddavoora 02/22/2023 2698951347 New UI changes fixed

Akhila 02/24/2023 2698951347 implemented preview file functionality in download configuration
Sohel 02/24/2023 2698964415 usage popup title changes
Sohel 02/24/2023 2698964415 Download Configuration Payload Changes
Sohel 02/24/2023 2698964415 usage popup title changes
Dilip 02/27/2023 2698951347 Fixed Sorting issue
Ravi 03/01/2023 2698951347 Added loader and download toast message for preview File
T Santosh Kumar 15/03/2023 2698951347 Responsive UI Changes
Suresh Peddavoora 03/15/2023 2698951347 Added Dropdown menu in Action Column in table
Suresh Peddavoora 03/16/2023 2701335619 Added Dropdown menu in Action Column in table
Raghu 03/16/2023 2701335619 Added Dropdown menu in Action Column in table
Raghu 03/04/2023 2701335619 added plus icon
Akhila 05/04/2023 2701335619 Added update date column and in payload
Ravi 05/31/2023 2701335619 changed delete popup message
Akhila 06/06/2023 2701335619 added code and description in action
Akhila 06/08/2023 2701335619 title label placeholder name change
Akhila 06/08/2023 2701335619 rearrange the column and form fields
Akhila 06/12/2023 2701335619 added role access
Gireesh 13-12-2023 2701335619 updated table columns
*/
import React, {createRef, useState, useEffect, useRef} from 'react';
import {TablePagination, Grid, Button, makeStyles} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import moment from 'moment';
import {httpGet, httpPaginationPost} from '../../../../../util/Rest';
import {MTableToolbar} from 'material-table';
// import DataUsageIcon from "@material-ui/icons/DataUsage";
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchBasicInfoData,
  resetBasicInfo,
  resetDataManagerRecordGroup,
  postPrintImportRecordGroup,
  setIsDraftRecordGroup,
  resetBasicInfoRecordGroup,
  setLastStepRecordGroupRedux,
  setFixedLengthRedux,
  fetchDataManagerRecordGroupUsage,
  resetDataManagerRecordGroupUsage,
  resetConfigUrl,
  resetDockey,
} from '../../../../../redux/reducers/DataManagerRecordGroup';
import {
  ErrorSnackbar,
  SuccessSnackbar,
  WarningSnackbar,
} from '../../../../../components/CustomSnackBar';
import {useUpdateEffect} from 'react-use';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import PageLoader from '../../../../../components/PageLoader';
import DialogBox from '../../../../../components/DialogBox';
import CopyRecordGroup from './CopyRecordGroup';
import ImportManagerRecordGroupNotes from './ImportManagerRecordGroupNotes';
import {resetDataManagerRecord} from '../../../../../redux/reducers/DataManagerRecord';
import ActionMenuItem from '../../../../../util/ActionMenuItem';
import UsageMessage from '../../../../../util/UsageMessage';
import SaveIcon from '@material-ui/icons/Save';
import OverrideRule from '../../../../../components/OverrideRule';
import {postPrintUsage, resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import {
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
} from '../../../../../redux/reducers/ReportMaster';
import {resetDownloadMsg} from '../../../../../redux/reducers/PreviewFileData';
import {downloadButton} from '../../../../../util/Content';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import axios from 'axios';
import AddIcon from '@material-ui/icons/AddOutlined';
const useStyles = makeStyles((theme) => ({
  'link': {
    color: '#320469 !important',
    borderBottom: '1px solid #000099',
  },
  ' & .MuiSvgIcon-root': {
    backgroundColor: '#320469 !important',
  },
}));
function SearchIMRTable({
  setValue = () => {},
  searchData,
  submit,
  setSubmit,
  tempUnCheckedRef,
  mapRecords,
  records,
  tempSelectedRows,
  setTempSelectedRows,
  recordGroupType,
  exportManagerRecordGroup,
  parentRecordException,
  includeAudit,
  category,
  setDataManagerRecordGroupData = () => {},
  setEditExisting,
  importRecordGroupAccess,
}) {
  const tableRef = createRef();
  const classes1 = useStyles();
  const dispatch = useDispatch();
  const [isDelete, setIsDelete] = useState(false);
  const [tstmsg, setToastMsg] = useState('');
  const [status, setStatus] = useState(false);
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [rows, setRows] = useState(defaultRows);
  const deletedId = useRef('');
  const [oldGroupCodeData, setOldGroupCodeData] = useState({});
  const [copyRecordGroup, setCopyRecordGroup] = useState(false);
  const [isNote, setIsNote] = useState(false);
  const [imrgData, setImrgData] = useState();
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);
  const [customError, setCustomError] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [resultCount, setResultCount] = useState(0);
  const [isUsage, setIsUsage] = useState(false);
  const {
    successMsg,
    errorMsg,
    addBasicInfoStatus,
    isLoading,
    dataManagerRecordGroupUsage,
    configurationUrl,
    dockey,
  } = useSelector(({dataManagerRecordGroup}) => dataManagerRecordGroup);
  const [arrayLast, setArrayLast] = useState(false);
  const queryRef = useRef(null);
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);
  const handleClose = () => {
    setIsDelete(false);
    setUserMetrixDelete(false);
  };
  const onEditCall = (rowData) => {
    dispatch(
      setIsDraftRecordGroup({
        property: 'isDraftRecordGroup',
        value: rowData?.isDraft,
      }),
    );
    dispatch(
      setLastStepRecordGroupRedux({
        property: 'lastStep',
        value: rowData?.lastStep,
      }),
    );
    dispatch(
      setFixedLengthRedux({
        property: 'fixedLength',
        value: rowData?.fixedLength,
      }),
    );
  };
  const columns = [
    {
      title: `${exportManagerRecordGroup ?  `Export` : `Import`} Record Group Name`,
      field: 'groupCode',
      render: (rowData) =>
        mapRecords ? (
          rowData?.groupCode
        ) : (
          <span
            role="button"
            className={classes1.link}
            onClick={() => {
              setEditExisting('Import Record Group');
              onEditCall(rowData);
              dispatch(fetchBasicInfoData(rowData?.dmRecordGroupId));
              setValue(1);
            }}
          >
            {rowData?.groupCode?.replace(/ /g, '\u00a0')}
          </span>
        ),
    },
    {
      title: `${exportManagerRecordGroup ?  `Export` : `Import`} Record Group Description`,
      field: 'groupDescription',
      render: (rowData) => rowData?.groupDescription?.replace(/ /g, '\u00a0')
    },
    {
      title: 'Record Group Type',
      field: 'groupType',
    },
    {
      title: 'Master Record',
      field: 'masterRecord',
      hidden: !mapRecords,
      render: (rowData) => {
        return rowData?.masterRecord ? rowData?.masterRecord : '-';
      },
    },
    {
      title: 'Created For',
      field: 'createdFor',
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDt',
      render: (rowData) => {
        return rowData?.createdDt ? moment(rowData?.createdDt).format('MM/DD/YYYY') : '';
      },
    },
    {
      title: 'Updated Date',
      field: 'updatedDate',
      render: (rowData) => {
        return rowData?.updatedDate ?
          moment(rowData?.updatedDate).tz('America/New_York').format('MM/DD/YYYY hh:mm:ss A') :
          '';
      },
    },
    {
      title: 'Status',
      field: 'isDraft',
      render: (rowData) =>
        rowData?.isDraft === 'Y' ? (
          <div className="completed-status status">
            <span style={{color: '#ff8b00', fontWeight: 'bold'}}>Draft</span>
          </div>
        ) : (
          <div className="completed-status status" style={{fontWeight: 'bold', color: '#00af00'}}>
            <span>Completed</span>
          </div>
        ),
    },
  ];
  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 1500);
    }
  }, [tstmsg, deleteErrorMsg]);

  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);

  useEffect(() => {
    dispatch(resetDataManagerRecordGroup());
    dispatch(resetBasicInfoRecordGroup());
    dispatch(resetDataManagerRecord());
    dispatch(
      setIsDraftRecordGroup({
        property: 'isDraftRecordGroup',
        value: '',
      }),
    );
    dispatch(
      setLastStepRecordGroupRedux({
        property: 'lastStep',
        value: 0,
      }),
    );
    dispatch(
      setFixedLengthRedux({
        property: 'fixedLength',
        value: '',
      }),
    );
  }, []);
  const handleDelete = (rowData) => {
    dispatch(fetchDataManagerRecordGroupUsage('Import', rowData.dmRecordGroupId));
    setIsDelete(false);
    setDeleteUsage(true);
    deletedId.current = rowData;
  };
  
  const handleSubmit = () => {
    httpGet(`record/group/delete/${deletedId.current?.dmRecordGroupId}`)
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.message);
          setIsDelete(false);
          setStatus(true);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setIsDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleCopyRecordGroup = () => {
    setCopyRecordGroup(false);
  };
  const handleCloseNotesDialog = () => {
    setIsNote(false);
  };

  const [loading, setIsLoadingDelete] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };

  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingDelete(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingDelete(false);
      }
      readData();
    }
  }, [configurationUrl]);

  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      dispatch(fetchCreatedForDropDownData('importrecordgroup'));
      dispatch(fetchCreatedByDropDownData('importrecordgroup'));
      setStatus(false);
    }
  }, [status]);

  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
      }, 1500);
    }
  }, [successMsg, errorMsg]);
  useEffect(() => {
    if (addBasicInfoStatus === 200 && successMsg) {
      if (oldGroupCodeData?.isDraft) {
        dispatch(
          setIsDraftRecordGroup({
            property: 'isDraftRecordGroup',
            value: oldGroupCodeData?.isDraft ? oldGroupCodeData?.isDraft : '',
          }),
        );
      }
      setTimeout(() => {
        dispatch(resetBasicInfo());
        setValue(1);
      }, 1500);
    }
  }, [successMsg, addBasicInfoStatus]);
  useEffect(() => {
    if (setTempSelectedRows) {
      setTempSelectedRows([]);
      tempUnCheckedRef.current = [];
    }
  }, []);
  const IMRecordGroupSessionStorage = JSON.parse(sessionStorage.getItem('IMRecordGroup'));
  if (IMRecordGroupSessionStorage && !submit && !mapRecords) {
    searchData = IMRecordGroupSessionStorage;
  }
  useEffect(() => {
    if (dataManagerRecordGroupUsage?.userMetrix === 'No') {
      if (deleteUsage) {
        setUserMetrixDelete(false);
        setIsDelete(true);
      } else {
        setCustomError(true);
        setTimeout(() => {
          setCustomError(false);
          dispatch(resetDataManagerRecordGroupUsage());
        }, 3000);
      }
    } else if (dataManagerRecordGroupUsage?.userMetrix === 'Yes') {
      if (deleteUsage) {
        setIsDelete(true);
        setUserMetrixDelete(true);
      } else {
        setValue(2);
      }
    }
  }, [dataManagerRecordGroupUsage]);
  const handleDeleteUsage = () => {
    if (isDelete && userMetrixDelete) {
      setIsUsage(true);
      setIsDelete(false);
      setUserMetrixDelete(false);
    } else {
      handleSubmit();
    }
  };
  useEffect(() => {
    setCustomError(false);
    setValue(0);
    isDelete && setIsDelete(false);
  }, []);

  const handleEdit = (rowData) => {
    setEditExisting('Import Record Group');
    onEditCall(rowData);
    dispatch(fetchBasicInfoData(rowData?.dmRecordGroupId));
    setValue(1);
  };
  const handleCopy = (rowData) => {
    setOldGroupCodeData(rowData);
    setCopyRecordGroup(true);
  };
  const handleUsage = (rowData) => {
    setDeleteUsage(false);
    setDataManagerRecordGroupData(rowData);
    dispatch(fetchDataManagerRecordGroupUsage('Import', rowData.dmRecordGroupId));
  };
  const handleNotes = (rowData) => {
    setIsNote(true);
    setImrgData(rowData);
  };
  return (
    <>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Import Record Groups'}
      />
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title={userMetrixDelete ? 'Import Record Groups Usage' : 'Delete Import Record Group'}
        value={
          userMetrixDelete ? (
            <UsageMessage value={'Import Record Groups'} />
          ) : (
            `Are you sure want to delete the ${deletedId.current?.groupCode?.replace(/ /g, '\u00a0')} Imports Record Group?`
          )
        }
        buttonCondition={userMetrixDelete}
        handleSubmit={handleDeleteUsage}
      />
      <OverrideRule
        dialogTitle="Import Record Groups Usage"
        dialogOpen={isUsage}
        dialogClose={() => setIsUsage((state) => !state)}
        title={`${deletedId.current?.groupCode?.replace(/ /g, '\u00a0') || ''} - ${
          deletedId.current?.groupDescription?.replace(/ /g, '\u00a0') || ''
        } Import Record Groups has been used in the following Imports.`}
        data={dataManagerRecordGroupUsage?.placeResponse}
        isOverRide={false}
      />
      <DialogBox
        open={copyRecordGroup}
        dialogClose={handleCopyRecordGroup}
        title={`Copy Import Record Group`}
        maxWidth="md"
        hideFooter={true}
      >
        <CopyRecordGroup oldGroupCodeData={oldGroupCodeData} type={'Import'} />
      </DialogBox>
      <DialogBox
        open={isNote}
        dialogClose={handleCloseNotesDialog}
        title="Import Record Groups Notes"
        maxWidth="lg"
      >
        <ImportManagerRecordGroupNotes importRecordGroupAccess={importRecordGroupAccess} imrgData={imrgData} type={'Import'} />
      </DialogBox>
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-toolbar-icons custom-actions-icon actions-dropdown-table new-standard-textfields">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            onSelectionChange={(rows, row) => {
              if (row?.tableData?.checked) {
                if (tempSelectedRows) {
                  const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                  arr.push({
                    ...row,
                    recordCode: row.groupCode,
                    recordDescription: row.groupDescription,
                    recordType: row.groupType,
                    tableData: {...row.tableData, id: row.groupCode},
                  });
                  setTempSelectedRows(arr);
                }
              } else {
                tempUnCheckedRef.current.push(row);
                const updatedRows = [...tempSelectedRows]
                  .filter((ele) => ele?.groupCode !== row?.groupCode)
                  .map((ele) => {
                    return {
                      ...ele,
                    };
                  });
                setTempSelectedRows(updatedRows);
              }
            }}
            data={(query) =>
              new Promise((resolve) => {
                const url = `record/group/search/all`;
                const bodyObj = {
                  limit: query?.pageSize ? query?.pageSize : null,
                  groupCode: searchData?.importMRGroupCode ? searchData?.importMRGroupCode?.toUpperCase() : '',
                  groupType: searchData?.importMRGroupType?.value ?
                    searchData?.importMRGroupType?.value :
                    '',
                  groupDescription: searchData?.importMRGroupDescripton ?
                    searchData?.importMRGroupDescripton :
                    '',
                  createdFor: searchData?.createdFor?.userLoginName ?
                    searchData?.createdFor?.userLoginName :
                    '',
                  createdBy: searchData?.createdBy?.userLoginName ?
                    searchData?.createdBy?.userLoginName :
                    '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  orderBy: query?.orderBy && query?.orderBy?.field ? query?.orderBy?.field : '',
                  isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  tabType: exportManagerRecordGroup ? 'Export' : 'Import',
                  masterRecord: parentRecordException ? parentRecordException : '',
                  includeAudit: includeAudit,
                  category: category,
                };
                queryRef.current = query;
                // setOrder({
                //   orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : "",
                //   orderDirection: query?.orderDirection ? query?.orderDirection : "",
                // });
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.response;
                        const newObj = {};
                        if (mapRecords) {
                          [...records, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.recordCode]) {
                              newObj[el.recordCode] = el;
                            }
                          });
                        }
                        const newRows = data?.map((elem) => {
                          if (newObj[elem.groupCode]) {
                            return {...elem, tableData: {...elem.tableData, checked: true}};
                          } else {
                            return {
                              ...elem,
                              tableData: {...elem.tableData, checked: false},
                            };
                          }
                        });
                        resolve({
                          data:
                            mapRecords && newRows?.length > 0 ?
                              newRows :
                              data.length > 0 ?
                                data :
                                [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                        setResultCount(response?.data?.response?.count);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbar: !mapRecords,
              selection: mapRecords,
              selectionProps: (row) => {
                let isDisabled = false;
                if (recordGroupType?.value && recordGroupType?.value !== 'Exception') {
                  const HeaderSelected = [...records, ...tempSelectedRows].filter(
                    (item) => item.recordType === recordGroupType?.value,
                  );
                  if (
                    HeaderSelected?.length === 1 &&
                    row.groupCode !== HeaderSelected[0]?.recordCode &&
                    recordGroupType?.value !== 'Data Export'
                  ) {
                    isDisabled = true;
                  }
                }
                return {
                  disabled: isDisabled,
                };
              },
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              {
                icon: () => <SaveIcon />,
                tooltip: 'Save User',
                onClick: (event, rowData) => console.log(rowData, 'rowData'),
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer pagination-block">
                  {!mapRecords ? (
                    <div className="mt-2">
                      <Button
                        type="button"
                        variant="outlined"
                        className={`mx-1 search-btn`}
                        disabled={Boolean(resultCount === 0)}
                        onClick={(event) => {
                          dispatch(
                            postPrintUsage({
                              baseCategory: '',
                              code: '',
                              description: '',
                              displayName: '',
                              fileType: '',
                              recordFormatType: '',
                              returnType: '',
                              sourceType: 'IMPORT RECORD GROUP',
                              isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                              search: '',
                              frameworkUsageOrderBy: '',
                              frameworkUsageOrderDerection: '',
                              fieldListOrderBy:
                                queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                  queryRef.current.orderBy.field :
                                  '',
                              fieldListOrderDerection: queryRef.current?.orderDirection ?
                                queryRef.current?.orderDirection :
                                '',
                              category: searchData?.category?.categoryCode ?
                                searchData?.category?.categoryCode :
                                '',
                              fieldName: '',
                              repositoryDescription: '',
                              repositoryName: '',
                              repositoryType: '',
                              createdBy: '',
                              groupCode: searchData?.importMRGroupCode ?
                                searchData?.importMRGroupCode :
                                '',
                              groupType: searchData?.importMRGroupType?.value ?
                                searchData?.importMRGroupType?.value :
                                '',
                              groupDescription: searchData?.importMRGroupDescripton ?
                                searchData?.importMRGroupDescripton :
                                '',
                              createdDate: searchData?.createdDate ?
                                moment(searchData?.createdDate).format('MM/DD/YYYY') :
                                '',
                            }),
                          );
                        }}
                      >
                        Download Configuration Usage
                      </Button>
                      <Button
                        type="button"
                        variant="outlined"
                        className={`search-btn ml-2 ${classes1.buttonRoot}`}
                        disabled={Boolean(resultCount === 0)}
                        onClick={() => {
                          dispatch(
                            postPrintImportRecordGroup(
                              {
                                groupCode: searchData?.importMRGroupCode ?
                                  searchData?.importMRGroupCode :
                                  '',
                                groupType: searchData?.importMRGroupType?.value ?
                                  searchData?.importMRGroupType?.value :
                                  '',
                                groupDescription: searchData?.importMRGroupDescripton ?
                                  searchData?.importMRGroupDescripton :
                                  '',
                                createdDate: searchData?.createdDate ?
                                  moment(searchData?.createdDate).format('MM/DD/YYYY') :
                                  '',
                                orderBy:
                                  queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                    queryRef.current.orderBy.field :
                                    '',
                                orderDirection: queryRef.current?.orderDirection ?
                                  queryRef.current?.orderDirection :
                                  '',
                                isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                                tabType: 'Import',
                                createdFor: searchData?.createdFor?.userLoginName ?
                                  searchData?.createdFor?.userLoginName :
                                  '',
                                createdBy: searchData?.createdBy?.userLoginName ?
                                  searchData?.createdBy?.userLoginName :
                                  '',
                              },
                              'Import',
                            ),
                          );
                        }}
                      >
                        {downloadButton}
                      </Button>
                    </div>
                  ) : null}
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleNotes={handleNotes}
                  handleUsage={handleUsage}
                  // handleRun={handleRun}
                  // handleExecution={handleExecution}
                  handleCopy={handleCopy}
                  hiddenMenu={{
                    edit: false,
                    run: true,
                    copy: false,
                    test: true,
                    notes: false,
                    execution: true,
                    usage: false,
                    user: true,
                    password: true,
                    delete: false,
                  }}
                  disableMenu={{
                    disableEdit: !importRecordGroupAccess?.edit,
                    disableRun: false,
                    disableCopy: !importRecordGroupAccess?.add,
                    disableExecution: false,
                    disableNotes: false,
                    disableTest: false,
                    disableUsage: false,
                    disableUser: false,
                    disablePassword: false,
                    disableDelete: !importRecordGroupAccess?.delete,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div>
                    {/* {mapRecord && ( */}
                    <Button
                      type="button"
                      variant="outlisetOpenned"
                      className={`mx-1 search-btn`}
                      disabled={!importRecordGroupAccess?.add}
                      isFreeAction={true}
                      onClick={(event) => {
                        setValue(1);
                        dispatch(resetDataManagerRecordGroup());
                        dispatch(
                          setIsDraftRecordGroup({
                            property: 'isDraftRecordGroup',
                            value: '',
                          }),
                        );
                        dispatch(
                          setLastStepRecordGroupRedux({
                            property: 'lastStep',
                            value: 0,
                          }),
                        );
                      }}
                      startIcon={<AddIcon />}
                    >
                      Add Import Record Group
                    </Button>
                    {/* )} */}
                  </div>
                </div>
              ),
            }}
            // actions={[
            //   {
            //     icon: () => (
            //       <>
            //         <Button type="button" variant="outlined" className={`search-btn`}>
            //           Add Record Group
            //         </Button>
            //       </>
            //     ),
            //     isFreeAction: true,
            //     onClick: () => {
            //       setValue(1);
            //       dispatch(resetDataManagerRecordGroup());
            //       dispatch(
            //         setIsDraftRecordGroup({
            //           property: "isDraftRecordGroup",
            //           value: "",
            //         })
            //       );
            //       dispatch(
            //         setLastStepRecordGroupRedux({
            //           property: "lastStep",
            //           value: 0,
            //         })
            //       );
            //     },
            //   },
            //   {
            //     icon: () => <EditOutlinedIcon />,
            //     tooltip: "Edit",
            //     onClick: (event, rowData) => {
            //       onEditCall(rowData);
            //       dispatch(fetchBasicInfoData(rowData?.groupCode));
            //       setValue(1);
            //     },
            //   },
            //   {
            //     icon: () => (
            //       <>
            //         <FileCopyOutlinedIcon />
            //       </>
            //     ),
            //     tooltip: "Copy",
            //     onClick: (event, rowData) => {
            //       setOldGroupCodeData(rowData);
            //       setCopyRecordGroup(true);
            //     },
            //   },
            //   {
            //     icon: () => <DataUsageIcon className={classes.copyButtonroot} />,
            //     tooltip: "Usage",
            //     onClick: (event, rowData) => {
            //       setDeleteUsage(false);
            //       setDataManagerRecordGroupData(rowData);
            //       dispatch(fetchDataManagerRecordGroupUsage("Import", rowData.groupCode));
            //     },
            //   },
            //   (rowData) => {
            //     return {
            //       icon: () => (
            //         <>
            //           <DeleteOutlineOutlinedIcon />
            //         </>
            //       ),
            //       tooltip: "Delete",
            //       onClick: () => {
            //         handleDelete(rowData);
            //       },
            //     };
            //   },
            //   {
            //     icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
            //     tooltip: "Import Record Group Notes",
            //     onClick: (event, rowData) => {
            //       setIsNote(true);
            //       setImrgData(rowData?.groupCode);
            //     },
            //   },
            // ]}
          />
        </div>
      </Grid>
      {(isLoading || printUsageIsLoading || loading) && <PageLoader />}
      {(deleteErrorMsg || errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={deleteErrorMsg || errorMsg || printUsageErrorMsg} />
      )}
      {(tstmsg || successMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar successMsg={tstmsg || successMsg || printUsageSuccessMsg} />
      )}
      {customError && (
        <WarningSnackbar errorMsg={`This Import Record Groups is not being used anywhere`} />
      )}
    </>
  );
}

export default SearchIMRTable;
